import * as Scrivito from "scrivito";
import moment from "moment";
import { truncate } from "lodash-es";
import I18n from "^/config/i18n";

import Breadcrumb from "^/Components/Breadcrumb";

const Details = Scrivito.connect(({ item }) => {
  const date = moment(item.get("publishedAt") || item.lastChanged());

  return (
    <div>
      <p className="font-weight-normal text-dark ">
        {I18n.t("search.date", {
          date,
          formatParams: {
            date: {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
            },
          },
        })}
      </p>
    </div>
  );
});

const ItemDescription = Scrivito.connect(({ description, item }) => {
  const descriptionText = description;

  return (
    <p className="font-weight-normal text-dark mb-2">
      {descriptionText || I18n.t("search.defaultDescription")}
      {item.objClass() === "ContactPage" && (
        <ul className="list-unstyled mb-3 mt-0">
          {item.get("altPhoneNumber") ||
            (item.get("phoneNumber") && (
              <li>
                <i className="las la-phone me-2" aria-hidden="true"></i>{" "}
                {item.get("altPhoneNumber") || item.get("phoneNumber")}
              </li>
            ))}
          {item.get("altEmail") ||
            (item.get("email") && (
              <li>
                <i className="las la-envelope me-2" aria-hidden="true"></i>{" "}
                {item.get("altEmail") || item.get("email")}
              </li>
            ))}
          {item.get("officeLocation") && (
            <li>
              <i className="las la-map-marker me-2" aria-hidden="true"></i>{" "}
              {item.get("officeLocation")}
            </li>
          )}
        </ul>
      )}
    </p>
  );
});

const iconMap = {
  Page: "file-alt",
  Download: "download",
  ContactPage: "user",
  CoursePage: "university",
  Event: "calendar",
  News: "newspaper",
};

function SearchResultItem({ resultItem }) {
  const title = resultItem.get("title") || I18n.t("search.defaultTitle");
  const extractedText = Scrivito.extractText(resultItem, { length: 350 });
  const description = truncate(extractedText, {
    length: 300,
    separator: /,? +/,
  });
  const icon =
    resultItem.get("navigationIcon") ||
    iconMap[resultItem.objClass()] ||
    "file";

  return (
    <>
      <Scrivito.LinkTag
        className="result-item"
        to={resultItem}
        hrefLang={resultItem.language()}
      >
        <h5 className="h5 result-title">
          <i
            className={`las la-${icon} me-2`}
            aria-label={resultItem.objClass()}
          />
          {title}
        </h5>
        <ItemDescription description={description} item={resultItem} />
        <Details item={resultItem} />
        <Breadcrumb
          objProps={resultItem}
          classNameProps="mb-0 pb-0"
          hasMedia={false}
        />
      </Scrivito.LinkTag>
    </>
  );
}

export default Scrivito.connect(SearchResultItem);
